import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../../assets/image/image";
import DonationContainer from "./index.css";

const Register = () => {
  return (
    <DonationContainer>
      <h1>정회원신청</h1>
      <div className="SubTitle">
        <span>
          CMS 정회원 신청서 ( <img src={Image.hangul} alt="hangul"></img>{" "}
          한글파일 )
          <Link to="/asset/cms_application.hwp" target="_blank">
            다운로드
          </Link>
        </span>
        <br></br>
        <span>
          신청서 작성 후 팩스(02-2647-1811) 또는 이메일(mir3768@naver.com)로
          신청
        </span>
      </div>
    </DonationContainer>
  );
};

export default Register;
